import React from 'react';
import PropTypes from 'prop-types';
import { A } from '@contently/toolkit';

const Story = (props) => {
  const { story } = props;
  const { title, link } = story;

  return (
    <div className="list-item-wrapper">
      <div className="list-item">
        <div className="flex-wrapper">
          <div className="flex-column flex-title">
            <A href={link} title={title}>{title}</A>
          </div>
        </div>
      </div>
    </div>
  );
};

Story.propTypes = {
  story: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  }).isRequired
};

export default Story;



// WEBPACK FOOTER //
// ./app/javascript/app/components/reassign_users/story.jsx